import React from "react"
import { View, CardNavigation } from "react-ame-components"
import Showcase from "../components/Showcase"
import img from "../assets/images/card_example.svg"

export class CardNavigationExample extends React.Component {
  state = {
    item: {
      title: "Posto BR Itaquaquecetuba",
      description: "Vendedor",
      rightIcon: "Vendedor",
    },
  }
  render() {
    return (
      <Showcase
        centerGrid
        title="Componente Card Navigation"
        description="Este componente ainda está sendo revisado">
        <View marginBottom="nano">
          <CardNavigation
            disabled
            leftIcon="ame-outline"
            title={this.state.item.title}
            description={this.state.item.description}
            rightIcon="right-next"></CardNavigation>
        </View>
        <View marginBottom="nano">
          <CardNavigation
            title={this.state.item.title}
            description={this.state.item.description}
            rightIcon="right-next"
            onClick={() => {
              console.log("Segundo card clicado")
            }}></CardNavigation>
        </View>
        <View>
          <CardNavigation
            leftImage={img}
            title={this.state.item.title}
            description={this.state.item.description}></CardNavigation>
        </View>
      </Showcase>
    )
  }
}
